/* ============================================================
   Biwa Wave — 凪 (Nagi)
   Lake-time light: html[data-bw-tod] / [data-bw-season] follow the
   visitor's clock. The CSS veil tints the page faintly with it.
   ============================================================ */
(function () {
  'use strict';

  function timeOfDay() {
    var h = new Date().getHours();
    if (h >= 5 && h < 8) return 'dawn';
    if (h >= 8 && h < 16) return 'day';
    if (h >= 16 && h < 19) return 'dusk';
    return 'night';
  }
  document.documentElement.setAttribute('data-bw-tod', timeOfDay());

  function season() {
    var m = new Date().getMonth() + 1;
    if (m >= 3 && m <= 5) return 'spring';
    if (m >= 6 && m <= 8) return 'summer';
    if (m >= 9 && m <= 11) return 'autumn';
    return 'winter';
  }
  document.documentElement.setAttribute('data-bw-season', season());

  function init() {
    if (document.querySelector('.bw-tod-veil')) return;
    var veil = document.createElement('div');
    veil.className = 'bw-tod-veil';
    veil.setAttribute('aria-hidden', 'true');
    document.body.appendChild(veil);
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
